import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortNumber'
})
export class ShortNumberPipe implements PipeTransform {

  transform(value: number): string {
    if (isNaN(value)) return '';

    if (value < 1000) {
      return value.toString();
    } else if (value >= 1000 && value < 1000000) {
      return (value / 1000).toFixed(1).replace(/\.0$/, '') + 'B';
    } else if (value >= 1000000 && value < 1000000000) {
      return (value / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    } else if (value >= 1000000000 && value < 1000000000000) {
      return (value / 1000000000).toFixed(1).replace(/\.0$/, '') + 'Mr';
    } else {
      return (value / 1000000000000).toFixed(1).replace(/\.0$/, '') + 'T';
    }
  }

}
